var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.778809,
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#DDEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.209 12.2842C17.6703 12.2842 16.4228 13.5316 16.4228 15.0704V15.1523C16.4228 15.6049 16.056 15.9718 15.6034 15.9718H14.1001C12.9016 15.9718 11.8906 16.8643 11.742 18.0535L11.2783 21.7631C11.1316 22.9367 11.8701 24.0395 13.0111 24.3506L19.7915 26.1998C20.4832 26.3885 21.2128 26.3885 21.9045 26.1998L28.6849 24.3506C29.8258 24.0395 30.5644 22.9367 30.4177 21.7632L29.954 18.0535C29.8053 16.8643 28.7944 15.9718 27.5959 15.9718H26.0926C25.64 15.9718 25.2731 15.6049 25.2731 15.1523V15.0704C25.2731 13.5316 24.0257 12.2842 22.4869 12.2842H19.209ZM22.9786 15.9718C23.4312 15.9718 23.7981 15.6049 23.7981 15.1523V15.0704C23.7981 14.3463 23.2111 13.7592 22.4869 13.7592H19.209C18.4849 13.7592 17.8979 14.3463 17.8979 15.0704V15.1523C17.8979 15.6049 18.2648 15.9718 18.7174 15.9718H22.9786ZM17.1604 17.4469H14.1001C13.6455 17.4469 13.262 17.7854 13.2056 18.2365L12.7419 21.9461C12.6863 22.3912 12.9664 22.8095 13.3992 22.9276L20.1796 24.7768C20.6172 24.8961 21.0788 24.8961 21.5164 24.7768L28.2968 22.9276C28.7295 22.8095 29.0097 22.3912 28.954 21.9461L28.4903 18.2365C28.4339 17.7854 28.0505 17.4469 27.5959 17.4469H24.5356H17.1604Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6523 23.6748V27.8208C12.6523 28.9254 13.5478 29.8208 14.6523 29.8208H27.0418C28.1463 29.8208 29.0418 28.9254 29.0418 27.8208V23.6748",
    stroke: "#2F80ED",
    strokeWidth: 1.47505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployers);
export default __webpack_public_path__ + "static/media/employers.161920c0fc8d1ca13c2f22873fde9ab0.svg";
export { ForwardRef as ReactComponent };